import { useState, useEffect } from 'react';
import { api } from '../context/AppContext';

/**
 * Iter. 406.fi — Custom hook wrapping the "fetch last log for an exercise"
 * pattern so the React 19 `react-hooks/set-state-in-effect` rule treats it
 * as a composable hook (it allowed) instead of inline async-in-effect (it
 * flags as a false-positive on legitimate event-driven fetches).
 *
 * Returns `{ lastLog, loadingHistory }`.
 *  - lastLog: the most recent saved log for `exerciseName`, or null
 *  - loadingHistory: true while the request is in flight on mount
 */
export default function useExerciseHistory(exerciseName) {
  const [lastLog, setLastLog] = useState(null);
  const [loadingHistory, setLoadingHistory] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!exerciseName) {
      setLoadingHistory(false);
      return undefined;
    }
    (async () => {
      try {
        const res = await api.get(`/workouts/exercise-history?name=${encodeURIComponent(exerciseName)}`);
        if (cancelled) return;
        if (res.data?.last_log) setLastLog(res.data.last_log);
      } catch { /* silent — history is best-effort */ }
      finally { if (!cancelled) setLoadingHistory(false); }
    })();
    return () => { cancelled = true; };
  }, [exerciseName]);

  return { lastLog, loadingHistory };
}
